import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { AvInvestmentScpi } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<AvInvestmentScpi> = {
      ownerId: [entity?.ownerId],
      productId: [entity?.productId],
      avInvestmentTypeScpi: [
        entity && entity?.avInvestmentTypeScpi
          ? entity?.avInvestmentTypeScpi
          : 'MONTHLY',
        Validators.required,
      ],
    };

    this.formBuilder.group(formConfig, options);
  }
  generate(entity: AvInvestmentScpi[], option) {
    const form = FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });

    return form;
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    return this.form.value.products;
  }
}
